import { Injectable } from '@angular/core';
import type { GraphQLParams, WorkCode } from '@tag/graphql';
import { Query, gql } from 'apollo-angular';
import { config } from '@tag/graphql';

export interface Response {
  workCodes: { items: WorkCode[]; totalCount: number };
}

@Injectable({
  providedIn: 'root',
})
export class WorkCodesGQL extends Query<Response, GraphQLParams<'workCode'>> {
  document = gql(config.workCode.query);
}
